'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setBrowserUnsupportedAcknowledgement = exports.getBrowserUnsupportedAcknowledgement = exports.isSupportedBrowser = exports.validateRequiredFeatures = exports.LOCAL_STORAGE_FEATURE_NAME = undefined;

var _REQUIRED_FEATURES;

var _lodash = require('lodash');

var _localStorage = require('../../../utils/services/localStorage/localStorage');

var _localStorage2 = _interopRequireDefault(_localStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib


// Services


/**
 * Feature detection extracted from Modernizr's source:
 * https://github.com/Modernizr/Modernizr/tree/master/feature-detects
 */
function createElement() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    if (typeof document.createElement !== 'function') {
        // This is the case in IE7, where the type of createElement is "object".
        // For this reason, we cannot call apply() as Object is not a Function.
        return document.createElement(args[0]);
    }
    return document.createElement.apply(document, args);
}

// Content editable
var contentEditableTest = function contentEditableTest() {
    // early bail out
    if (!('contentEditable' in document.documentElement)) {
        return;
    }

    // some mobile browsers (android < 3.0, iOS < 5) claim to support
    // contentEditable, but but don't really. This test checks to see
    // confirms whether or not it actually supports it.

    var div = createElement('div');
    div.contentEditable = true;
    return div.contentEditable === 'true';
};

// SVGs
var svgTest = function svgTest() {
    return !!document.createElementNS && !!document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect;
};

// Web sockets
var webSocketsTest = function webSocketsTest() {
    var protocol = 'https:' == location.protocol ? 'wss' : 'ws'; // eslint-disable-line

    if ('WebSocket' in window) {
        var protoBin = 'binaryType' in WebSocket.prototype;
        if (protoBin) {
            return protoBin;
        }
        try {
            return !!new WebSocket(protocol + '://.').binaryType;
        } catch (e) {
            // Do nothing
        }
    }
    return false;
};

// End Modernizr feature detection
var LOCAL_STORAGE_FEATURE_NAME = exports.LOCAL_STORAGE_FEATURE_NAME = 'localStorage';
var REQUIRED_FEATURES = (_REQUIRED_FEATURES = {}, _defineProperty(_REQUIRED_FEATURES, LOCAL_STORAGE_FEATURE_NAME, {
    test: _localStorage.localStorageFeatureTest
}), _defineProperty(_REQUIRED_FEATURES, 'contentEditable', {
    test: contentEditableTest
}), _defineProperty(_REQUIRED_FEATURES, 'svg', {
    test: svgTest
}), _defineProperty(_REQUIRED_FEATURES, 'webSockets', {
    test: webSocketsTest
}), _REQUIRED_FEATURES);

/**
 * Check if the required features work on this browser.
 */
var validateRequiredFeatures = exports.validateRequiredFeatures = function validateRequiredFeatures() {
    var isSupported = true;
    var errors = [];

    (0, _lodash.forOwn)(REQUIRED_FEATURES, function (featureData, featureName) {
        var featureTestResult = featureData.test();
        if (!featureTestResult) {
            console.warn('FEATURE WARNING: Required feature ' + featureName + ' is not supported by this browser');
            errors.push(featureName);
        }
        isSupported = isSupported && featureTestResult;
    });

    return {
        isSupported: isSupported,
        errors: errors
    };
};

var isSupportedBrowser = exports.isSupportedBrowser = function isSupportedBrowser() {
    var supportedBrowserRegex = /Safari|Chrome|Firefox|iPhone|iPad/;
    var unsupportedBrowserRegex = /Edge|MSIE|rv:11/;

    var userAgent = window.navigator.userAgent || '';
    return supportedBrowserRegex.test(userAgent) && !unsupportedBrowserRegex.test(userAgent);
};

var BROWSER_UNSUPPORTED_ACKNOWLEDGEMENT_KEY = 'unsupportedAcknowledgement';

var getBrowserUnsupportedAcknowledgement = exports.getBrowserUnsupportedAcknowledgement = function getBrowserUnsupportedAcknowledgement() {
    return _localStorage2.default.getItem(BROWSER_UNSUPPORTED_ACKNOWLEDGEMENT_KEY) === 'true';
};

var setBrowserUnsupportedAcknowledgement = exports.setBrowserUnsupportedAcknowledgement = function setBrowserUnsupportedAcknowledgement() {
    return _localStorage2.default.setItem(BROWSER_UNSUPPORTED_ACKNOWLEDGEMENT_KEY, true);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/error/browserSupport/browserDetectionService.js
// module id = 695
// module chunks = 0